import React, { useEffect, useState } from "react";
import { Grid, Card, CardContent, Typography, Box, Stack } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { GlobalContext } from "../../context/GlobalContext";
import { TranslateContext } from "../../context/TranslateContext";

const StatCard = ({ title, value, icon, color }) => (
  <Card>
    <CardContent>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="body2" color="text.secondary">
            {title}
          </Typography>
          <Typography variant="h4" fontWeight={700} mt={0.5}>
            {value}
          </Typography>
        </Box>
        <Box sx={{ p: 2, borderRadius: 2, bgcolor: color + "20", color }}>
          {icon}
        </Box>
      </Stack>
    </CardContent>
  </Card>
);

const AdminDashboardHome = () => {
  const { hitAxios } = React.useContext(GlobalContext);
  const { lang } = React.useContext(TranslateContext);
  const [stats, setStats] = useState({
    users: 0,
    orders: 0,
    downloads: 0,
    revenue: 0,
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    const [usersRes, ordersRes] = await Promise.all([
      hitAxios({
        path: "/api/user/admin-get-all",
        admin: true,
        showSnackbar: false,
      }),
      hitAxios({
        path: "/api/orders/admin-get-all",
        admin: true,
        showSnackbar: false,
      }),
    ]);

    const revenue =
      ordersRes?.data?.data
        ?.filter((o) => o.status === "completed")
        ?.reduce((acc, o) => acc + parseFloat(o.amount || 0), 0) || 0;

    setStats({
      users: usersRes?.data?.total || 0,
      orders: ordersRes?.data?.total || 0,
      revenue: revenue.toFixed(2),
      downloads: 0,
    });
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} mb={3}>
        {lang.dashboardOverview || "Dashboard Overview"}
      </Typography>

      {/* ✅ MUI v6+ Grid: no `item` prop, use `size` instead */}
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <StatCard
            title={lang.totalUsers || "Total Users"}
            value={stats.users}
            icon={<PeopleIcon />}
            color="#6366F1"
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <StatCard
            title={lang.totalOrders || "Total Orders"}
            value={stats.orders}
            icon={<ReceiptIcon />}
            color="#10B981"
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <StatCard
            title={lang.revenue || "Revenue"}
            value={`$${stats.revenue}`}
            icon={<AttachMoneyIcon />}
            color="#F59E0B"
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <StatCard
            title={lang.downloads || "Downloads"}
            value={stats.downloads}
            icon={<CloudDownloadIcon />}
            color="#3B82F6"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboardHome;
